<div class="content-with-stepper-and-title">
    <div class="row">
      <div class="col-4 col-pr-12 col-sm-4 col-md-4 col-lg-4 col-xl-4">
        <h2 class="title" id="maritalStatusComponentTitle1" [innerHtml]="copyService.copies.marital_status_copies.title_1"></h2>
        <div class="box-input">
          <voxel-form-field id="maritalStatusSelectionLabel" [label]="copyService.copies.marital_status_copies.marital_status_selection_label">
            <vcl-select id="autoCompleteComponent" [placeholder]="copyService.copies.marital_status_copies.filter_placeholder" (change)="selectOption($event)" required [notFoundTitle]="copyService.copies.marital_status_copies.filter_not_found_title" [notFoundMessage]="copyService.copies.marital_status_copies.filter_not_found_message">
              <vcl-select-option [id]="'maritalStatusSelection' + option.id" *ngFor="let option of options" [selected]="option.id === selectedMaritalStatus.marital_status_code" [value]="option">
                {{ option.value }}
              </vcl-select-option>
            </vcl-select>
          </voxel-form-field>
        </div>
      </div>
    </div>
    <app-controls id="maritalStatusBtns" [hasPrevious]="true" [nextLabel]="copyService.copies.marital_status_copies.button" (next)="next()" [nextDisabled]="validButton"></app-controls>
  </div>
  